import { Box, List, useMediaQuery, useTheme } from '@mui/material';
import SidebarItem from 'components/Layouts/components/SidebarItem';
import * as urls from 'routes/config';
import { Outlet, useLocation } from 'react-router-dom';

export default function Configuration() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  return (
    <Box display='flex' gap={4} minHeight='100vh'>
      {!isMediumScreen ? (
        <List
          sx={{
            minWidth: 162,
            maxWidth: 262,
            height: 'fit-content',
            background: theme.palette.background.paper,
            borderRadius: 2,
            position: 'sticky',
            top: '200px'
          }}
        >
          <SidebarItem to={urls.configuration.twilio} label='Twilio' />
          {location.pathname === '/agency/configuration/llm' && <SidebarItem to={urls.configuration.llm} label='LLM' />}
          {/* <SidebarItem to={urls.configuration.stripe} label='Stripe' /> */}
          <SidebarItem to={urls.configuration.smtp} label='SMTP' />
          <SidebarItem to={urls.configuration.pricing} label='Pricing' />
          <SidebarItem to={urls.configuration.branding} label='Branding' />
          <SidebarItem to={urls.configuration.access} label='Access' />
        </List>
      ) : (
        <List
          className='mobile-sidebar'
          sx={{
            display: 'flex',
            height: 'fit-content',
            background: theme.palette.background.paper,
            borderRadius: '12px',
            position: 'fixed',
            bottom: '10px',
            overflow: 'auto',
            zIndex: '1000',
            backgroundColor: '#EAE6FD',
            width: '-webkit-fill-available',
            marginRight: '24px'
          }}
        >
          <SidebarItem to={urls.configuration.twilio} label='Twilio' />
          <SidebarItem to={urls.configuration.llm} label='LLM' />
          <SidebarItem to={urls.configuration.stripe} label='Stripe' />
          <SidebarItem to={urls.configuration.smtp} label='SMTP' />
        </List>
      )}
      <Box width='100%' paddingBottom='100px'>
        <Outlet />
      </Box>
    </Box>
  );
}
